mx.app.widget.XformWindow = Ext.extend(mx.app.widget.WindowForm, {
    initComponent: function() {
        mx.app.widget.XformWindow.superclass.initComponent.apply(this, arguments);
    },
    getUrl: null,
    saveUrl: null,
    show: function(record) {
        mx.app.widget.XformWindow.superclass.show.apply(this, arguments);

        var reader = new mx.data.JsonReader(
            {
                totalProperty: 'total',
                successProperty: 'success',
                root: 'rows',
            },
            this.recordClass
        );

        if (this.getUrl) {
            this.el.mask();
            mx.data.Ajax.request({
                url: this.getUrl,
                method: 'GET',
                success: function(response) {
                    var o = reader.read(response);
                    if (o.success) {
                        this.el.unmask();
                        this.record = o.records[0];
                        this.form.getForm().loadRecord(this.record);
                        this.form.record = this.record;
                        if (this.form.onRecordLoaded) {
                            this.form.onRecordLoaded.call(this.form, this.form.record);
                        }
                    }
                },
                failure: function() {},
                scope: this,
            });
        }

        if (this.editable && this.saveUrl) {
            var showError = function(response) {
                Ext.Msg.show({
                    title: 'Error ' + (response.status > 0 ? response.status : ''),
                    msg: response.statusText,
                    icon: Ext.Msg.ERROR,
                    buttons: Ext.Msg.OK,
                });
            };
            var showWarning = function(response) {
                Ext.Msg.show({
                    title: 'Warning ' + (response.status > 0 ? response.status : ''),
                    msg: response.statusText,
                    icon: Ext.Msg.WARNING,
                    buttons: Ext.Msg.OK,
                });
            };
            this.okButton.handler = function() {
                if (this.form.getForm().isValid()) {
                    this.el.mask();

                    this.record.dirty = true;
                    this.form.getForm().updateRecord(this.record);
                    Ext.Ajax.request({
                        url: this.saveUrl,
                        success: function(response) {
                            this.el.unmask();
                            var o = reader.read(response);
                            if (o.success) {
                                this.fireEvent('success', o.records[0]);
                                this.destroy();
                                if (o.warnings.length) {
                                    var msg = [];
                                    o.warnings.forEach(function(i) {
                                        msg.push(i.message);
                                    });
                                    showWarning({
                                        status: 0,
                                        statusText: msg.join('<br />'),
                                    });
                                }
                            } else {
                                var errors = o.errors;
                                if (!Ext.isArray(errors)) {
                                    errors = [errors];
                                }
                                showError({
                                    status: 0,
                                    statusText: errors
                                        .map(function(error) {
                                            return error.message;
                                        })
                                        .join('<br />'),
                                });
                            }
                        },
                        failure: function(response) {
                            this.record.reject();
                            this.el.unmask();
                            this.fireEvent('failure', this.record);
                            showError(response);
                        },
                        scope: this,
                        jsonData: this.record.getData(),
                    });
                }
            };
        }
    },
});
